export const GET_EVENT = `
  query getEvent($id: Int!, $tenant_id: Int!) {
    getEvent(id: $id, tenant_id: $tenant_id) {
      __typename

      ... on Event {
        id
        title
        campaign_id
        perma_link
        closing_date
        description
        location
        from_time
        to_time
        offer_contact
        offer_donate
        header
        banner
        offer_announce
        donation_header
        donation_footer
        custom_notification
        custom_subject
        custom_body
        hide_name
        do_not_validate
        do_not_ask_cuit
        do_not_show_company_fields
        poll_welcome_message
        require_donate
        organization
        do_not_show_company_fields_members
        hide_previous_checkbox
        attachics
        ics
        closed_url
        required_poll
        custom_account
        conditions
        success_message
        closed_message
        banner_h
        banner_v
        custom_css
        approve_terms
        terms
        generate_ics
        redirect_url
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_EVENTS = `
  query getEvents(
    $skip: Int
    $take: Int
    $filter: FilterEventInput
    $orderBy: EventOrderInput
    $searchText: String
    $tenant_id: Int!
  ) {
    getEvents(
      skip: $skip
      take: $take
      filter: $filter
      orderBy: $orderBy
      searchText: $searchText
      tenant_id: $tenant_id
    ) {
      __typename

      ... on Event {
        id
        title
        campaign_id
        perma_link
        closing_date
        description
        location
        from_time
        to_time
        offer_contact
        offer_donate
        header
        banner
        offer_announce
        donation_header
        donation_footer
        custom_notification
        custom_subject
        custom_body
        hide_name
        do_not_validate
        do_not_ask_cuit
        do_not_show_company_fields
        poll_welcome_message
        require_donate
        organization
        do_not_show_company_fields_members
        hide_previous_checkbox
        attachics
        ics
        closed_url
        required_poll
        custom_account
        conditions
        success_message
        closed_message
        banner_h
        banner_v
        custom_css
        approve_terms
        terms
        generate_ics
        redirect_url
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_EVENT_BY_PERMALINK = `
  query getEventByPermalink($perma_link: String!) {
    getEventByPermalink(perma_link: $perma_link) {
      __typename

      ... on Event {
        id
        title
        campaign_id
        perma_link
        closing_date
        description
        location
        from_time
        to_time
        offer_contact
        offer_donate
        header
        banner
        offer_announce
        donation_header
        donation_footer
        custom_notification
        custom_subject
        custom_body
        hide_name
        do_not_validate
        do_not_ask_cuit
        do_not_show_company_fields
        poll_welcome_message
        require_donate
        organization
        do_not_show_company_fields_members
        hide_previous_checkbox
        attachics
        ics
        closed_url
        required_poll
        custom_account
        conditions
        success_message
        closed_message
        banner_h
        banner_v
        custom_css
        approve_terms
        terms
        generate_ics
        redirect_url
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EVENTS_COUNT = `
  query eventsCount(
    $tenant_id: Int!
    $filter: FilterEventInput
    $searchText: String
  ) {
    eventsCount(
      tenant_id: $tenant_id
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
